module.exports = __webpack_public_path__ + "img/no_data.28a02585.png";